import { CardHeader, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { BOX_SHADOW_ON_WHITE_BG } from 'src/shared/constants/styling-constants'
import { CheckboxData, CheckboxGroupField } from 'src/shared/form/control/CheckboxGroupField'
import { ListSelectionIcon } from 'src/shared/icons/Icons'
import { ExpandableCard } from 'src/shared/presentation/ExpandableCard'
import styled from 'styled-components'

interface Props {
  categoryName: string
  checkboxData: CheckboxData[]
  name: string
  showSelectionWithinGroupIcon: boolean
}

const ExpandableCardStyled = styled(ExpandableCard)`
  box-shadow: ${BOX_SHADOW_ON_WHITE_BG.default};

  &:hover {
    box-shadow: ${BOX_SHADOW_ON_WHITE_BG.hover};
  }

  .MuiCardContent-root {
    padding: 0;

    &:last-child {
      padding-bottom: 0;
    }

    .MuiFormHelperText-root {
      display: none;
    }

    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`

const CardHeaderStyled = styled(CardHeader)`
  height: 3rem;

  .MuiCardHeader-content {
    display: flex;
    gap: ${({ theme }) => theme.spacing(2)};
    align-items: center;
  }
`

export const ExpandableEffectivenessClassificationSelectionCard = ({
  categoryName,
  checkboxData,
  name,
  showSelectionWithinGroupIcon,
}: Props): ReactElement => {
  return (
    <ExpandableCardStyled
      header={
        <CardHeaderStyled
          title={
            <>
              <Typography variant="subtitle2">{categoryName}</Typography>
              {showSelectionWithinGroupIcon && <ListSelectionIcon color="action" />}
            </>
          }
          disableTypography
        />
      }
      content={<CheckboxGroupField name={name} data={checkboxData} />}
    />
  )
}
